/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { inject } from '@angular/core';
import { MeasureCommand } from './measure.command';
import { Store } from '@ngxs/store';
import { MapInteractionsService } from '../../services/mapInteractions.service';
import { MeasureDialog } from './measure-dialog.service';

export function measureFactory() {
    const command = new MeasureCommand();
    command.setDependencies({
        store: inject(Store),
        interactions: inject(MapInteractionsService),
        dialog: inject(MeasureDialog),
    });
    return command;
}
